<div style="height:100%; padding-left: 0px; padding-right: 0px; padding-bottom: 0px; margin-bottom: 0px" id="reportContainer"></div>
